import { I18n } from '../strings-keys';

export const XuxViewSelectorStaticContent = Object.freeze({
  buttonCollapseTitle: I18n.Common.CollapseAll,
  buttonExpandTitle: I18n.Common.ExpandAll,
  defaultViewName: I18n.Common.View,
  defaultView: I18n.Common.DefaultView,
  saveAsNewView: I18n.Components.XuxViewSelector.SaveAsNewView,
  save: I18n.Common.Save,
  noSavedViewsYet: I18n.Components.XuxViewSelector.NoSavedViewsYet,
  viewNamePlaceholder: I18n.Components.XuxViewSelector.TypeViewName,
});
